import { BannerHeading } from '../../global/typography';
import StyledButton from '../../components/Button/Button';
import { buttonVariant } from '../../types/buttonTypes';
import {
    StyledSection,
    StyledContainer,
    StyledHeading,
    StyledSubtitle,
    StyledParagraph,
    ButtonContainer,
    ContentContainer,
} from './styles';
import { BaseSection } from '../../components/BaseSection';
import { Box, BoxProps } from '@chakra-ui/react';

export interface MigrationSectionProps extends BoxProps {
    image: {
        url: string;
    };
    title: string;
    boxSide: 'left' | 'right';
    subtitle?: string;
    children: string | JSX.Element | JSX.Element;
    ctaButton?: {
        title: string;
        href: string;
        variant: buttonVariant;
        target?: string;
    };
}

const MigrationSection: React.FC<MigrationSectionProps> = ({
    image,
    boxSide,
    title,
    subtitle,
    children,
    ctaButton,
    ...props
}) => {
    return (
        <Box {...props}>
            <StyledSection $imageUrl={image.url}>
                <StyledContainer $flex="column" $side={boxSide}>
                    <ContentContainer>
                        <StyledHeading>{title}</StyledHeading>
                        <StyledSubtitle>{subtitle}</StyledSubtitle>
                        {children}
                    </ContentContainer>
                    {ctaButton && (
                        <ButtonContainer>
                            <StyledButton
                                href={ctaButton.href}
                                style={ctaButton.variant}
                                target={ctaButton.target || '_blank'}
                            >
                                {ctaButton.title}
                            </StyledButton>
                        </ButtonContainer>
                    )}
                </StyledContainer>
            </StyledSection>
        </Box>
    );
};

export default MigrationSection;
